export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const inrShort = (n) => {
  const v = Number(n || 0);
  if (Math.abs(v) >= 10000000) return "₹" + (v / 10000000).toFixed(2) + " Cr";
  if (Math.abs(v) >= 100000) return "₹" + (v / 100000).toFixed(2) + " L";
  if (Math.abs(v) >= 1000) return "₹" + (v / 1000).toFixed(1) + "K";
  return inr(v);
};

export const num = (n) => Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const dmy = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  if (isNaN(d)) return iso;
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};

export const dmyTime = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return `${dmy(iso)} ${d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true })}`;
};

export const todayStr = () => new Date().toISOString().slice(0, 10);
export const daysAgoStr = (n) => new Date(Date.now() - n * 86400000).toISOString().slice(0, 10);

export const statusTone = (status) =>
  ({
    "IN STOCK": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "LOW STOCK": "bg-amber-50 text-amber-700 border-amber-200",
    "OUT OF STOCK": "bg-rose-50 text-rose-700 border-rose-200",
    INACTIVE: "bg-slate-100 text-slate-600 border-slate-200",
    PAID: "bg-emerald-50 text-emerald-700 border-emerald-200",
    PARTIAL: "bg-amber-50 text-amber-700 border-amber-200",
    UNPAID: "bg-rose-50 text-rose-700 border-rose-200",
    COMPLETED: "bg-indigo-50 text-indigo-700 border-indigo-200",
    VOID: "bg-slate-200 text-slate-700 border-slate-300",
  }[status] || "bg-slate-50 text-slate-600 border-slate-200");

export const uid = () =>
  "bds-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);

export const csvDownload = (filename, rows) => {
  if (!rows?.length) return;
  const keys = Object.keys(rows[0]);
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const csv = [keys.join(","), ...rows.map((r) => keys.map((k) => esc(r[k])).join(","))].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
};
